import { Calendar as AntCalendar } from 'antd'
import type { Moment } from 'moment-timezone'
import momentGenerateConfig from 'rc-picker/es/generate/moment'

export const Calendar = AntCalendar.generateCalendar<Moment>(momentGenerateConfig)
